const STYLES = {
  borrador: { bg: 'bg-neutral-800', text: 'text-neutral-400', label: 'Borrador' },
  enviada: { bg: 'bg-blue-500/10', text: 'text-blue-400', label: 'Enviada' },
  aceptada: { bg: 'bg-green-500/10', text: 'text-green-400', label: 'Aceptada' },
  rechazada: { bg: 'bg-red-500/10', text: 'text-red-400', label: 'Rechazada' },
};

export default function StatusBadge({ status }) {
  const s = STYLES[status] || {
    bg: 'bg-neutral-800',
    text: 'text-neutral-400',
    label: status,
  };
  return (
    <span className={`px-2.5 py-1 rounded-md text-xs font-medium ${s.bg} ${s.text}`}>
      {s.label}
    </span>
  );
}
